import { render } from "./MultiselectAnswer.vue?vue&type=template&id=24f3d915"
import script from "./MultiselectAnswer.vue?vue&type=script&lang=js"
export * from "./MultiselectAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__